import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	stroke: "#262626",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M20.249 18.754V20.254C20.249 21.0824 19.5775 21.754 18.749 21.754H14.249",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.249 3.754H18.749C19.5775 3.754 20.249 4.42557 20.249 5.254V6.754",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.393 23.246L1.39302 21.96C1.02368 21.9073 0.749258 21.5911 0.749024 21.218V3.72501C0.748733 3.37107 0.995924 3.0651 1.34202 2.99101L10.342 0.770011C10.5636 0.722581 10.7947 0.777852 10.9708 0.920386C11.147 1.06292 11.2492 1.27743 11.249 1.50401V22.504C11.2489 22.7213 11.1545 22.9279 10.9903 23.0703C10.8261 23.2126 10.6082 23.2767 10.393 23.246Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.249 9.75302L23.249 12.753H14.999",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.25 15.753L23.25 12.753",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.87401 11.629C7.72198 11.629 7.58499 11.7208 7.52719 11.8614C7.46939 12.0021 7.50222 12.1637 7.6103 12.2706C7.71838 12.3775 7.88032 12.4086 8.02031 12.3493C8.1603 12.29 8.25064 12.152 8.24901 12C8.24928 11.9005 8.20986 11.8049 8.13947 11.7345C8.06909 11.6642 7.97355 11.6247 7.87401 11.625V11.625",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2225%22%20viewBox%3D%220%200%2024%2025%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20stroke%3D%22%23262626%22%3E%3Cpath%20d%3D%22M20.249%2018.754V20.254C20.249%2021.0824%2019.5775%2021.754%2018.749%2021.754H14.249%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M14.249%203.754H18.749C19.5775%203.754%2020.249%204.42557%2020.249%205.254V6.754%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M10.393%2023.246L1.39302%2021.96C1.02368%2021.9073%200.749258%2021.5911%200.749024%2021.218V3.72501C0.748733%203.37107%200.995924%203.0651%201.34202%202.99101L10.342%200.770011C10.5636%200.722581%2010.7947%200.777852%2010.9708%200.920386C11.147%201.06292%2011.2492%201.27743%2011.249%201.50401V22.504C11.2489%2022.7213%2011.1545%2022.9279%2010.9903%2023.0703C10.8261%2023.2126%2010.6082%2023.2767%2010.393%2023.246Z%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M20.249%209.75302L23.249%2012.753H14.999%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M20.25%2015.753L23.25%2012.753%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M7.87401%2011.629C7.72198%2011.629%207.58499%2011.7208%207.52719%2011.8614C7.46939%2012.0021%207.50222%2012.1637%207.6103%2012.2706C7.71838%2012.3775%207.88032%2012.4086%208.02031%2012.3493C8.1603%2012.29%208.25064%2012.152%208.24901%2012C8.24928%2011.9005%208.20986%2011.8049%208.13947%2011.7345C8.06909%2011.6642%207.97355%2011.6247%207.87401%2011.625V11.625%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E%0A";
